<template>
    <div>
        <custom-modal v-if="showModal" @close="closeModal" :modalSmall="true">
            <div slot="body">
                <div>
                  <h3 class="bold">{{ $t('confirmSubmitForm') }}</h3>
                  <div class="modal-bottombar">
                        <div class="buttons-modal text-center">
                            <a @click="confirmSubmit()">{{ $t('approve') }}</a>
                            <a @click="closeModal()">{{ $t('cancel') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </custom-modal>
        <footer>
            <div class="bottom-menu">
                <div class="columns is-mobile">
                    <div class="column flexbox-center-left" @click="handlePreviousStep()">
                      <!-- <icon class="small-svg" name="arrow-left"></icon> -->
                      <a>{{ $t('previous') }}</a>
                    </div>

                    <div class="column flexbox-center-right" @click="submitForm ? handleSubmit() : onNextClicked()">
                      <a>{{stepText}}</a>
                      <!-- <icon class="small-svg" name="arrow-right"></icon> -->
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import customModal from "./../modal/custom-modal";
import { EventBus } from "../../../main";
import * as formValidation from '../../../js/formValidation.js'

export default {
  name: "bottombar",
  components: {
    "custom-modal": customModal
  },
  data() {
    return {
      submitForm: false,
      showModal: false
    };
  },
  computed: {
    ...mapGetters({
      form: "getActiveForm",
      components: "getComponents",
      activeRegistration: "getActiveRegistration"
    }),
    stepText() {
      let selectedIndex = null;
      for (let i = 0; this.components.length > i; i++) {
        if (selectedIndex !== null && selectedIndex < i) {
          if (!this.components[i].disabled) {
            this.setSubmitForm(false);
            return this.$t("next");
          }
        }
        if (this.components[i].active) {
          selectedIndex = i;
        }
      }
      this.setSubmitForm(true);
      return this.$t("submit");
    }
  },
  methods: {
    ...mapActions({
      handleNextStep: "handleNextStep",
      handlePreviousStep: "handlePreviousStep"
    }),
    setSubmitForm(boolean) {
      this.submitForm = boolean;
    },
    handleSubmit() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    confirmSubmit() {
      this.showModal = false;
      this.$router.push({
        name: "Kvittering"
      });
    },
    onNextClicked() {
      let activeComp = this.getActiveComponent();
      if (activeComp.name == "form-registration"){
        if (this.validateForm())
          this.handleNextStep();
      }
      else {
        this.handleNextStep();
      }
    },
    getActiveComponent() {
      for (let i = 0; this.components.length > i; i++) {
        if (this.components[i].active) {
          return this.components[i];
        }
      }
    },
    validateForm(){
      let isValid = formValidation.validateForm(this.activeRegistration);
      EventBus.$emit('onFormValidation', isValid); // This calls the onValidation event listener in Registration.vue
      return isValid;
    }
  }
};
</script>
